<template>
    <div class="app-header-menu" :class="menuClasses">
        <nuxt-link :class="menuItemClasses" to="/"> Home </nuxt-link>
        <a :class="menuItemClasses" :href="$config.public.courseUrl"> Course </a>
        <nuxt-link :class="menuItemClasses" to="/contact"> Contact </nuxt-link>
    </div>
</template>

<script>
export default {
    name: 'AppHeaderMenu',
    computed: {
        menuClasses() {
            const cls = {};
            cls['hidden md:flex md:gap-x-12 pt-4 pr-14'] = true;
            return cls;
        },
        menuItemClasses() {
            const cls = {};
            cls['text-base font-bold leading-6 text-white'] = true;
            return cls;
        },
    },
};
</script>
